import { useEffect, type CSSProperties } from 'react';
import ForgotPasswordCard from '@/components/auth/ForgotPasswordCard';
import LoginHero from '@/components/auth/LoginHero';
import { APP_NAME } from '@/config/productBrand';
import { useLoginPage } from '@/hooks/useLoginPage';
import './tripzaLogin.css';

/**
 * Reset password — the map scene with the reset card in place of the sign-in card, under the same name
 * the sign-in page shows: the company's on its own domain, TravelERP's everywhere else.
 *
 * Nothing here decides anything. Unlike the login page there is no signed-in redirect: a person
 * already signed in may legitimately be resetting a password, and bouncing them to the dashboard
 * would make the link look broken.
 */
export default function ForgotPasswordPage() {
  const brand = useLoginPage().data?.brand ?? null;

  useEffect(() => {
    const previous = document.title;
    document.title = `Reset password — ${brand?.companyName ?? APP_NAME}`;
    return () => { document.title = previous; };
  }, [brand?.companyName]);

  const style = (brand ? { '--red': brand.primaryColor, '--red2': brand.primaryColor } : undefined) as CSSProperties | undefined;

  return (
    <main className="tz" style={style}>
      <LoginHero brand={brand} />
      <ForgotPasswordCard />
    </main>
  );
}
